<template>
  <div>
    <board-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                       :paginationData="filterSet.page"></board-filter-link>
    <board-list-link :listLayout="listLayout" :boardData="List" :paginationData="filterSet.page" v-loading="!finishGetList"
                     :boardType="boardType"></board-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import BoardFilterLink from "@/components/board/BoardFilterLink";
import BoardListLink from "@/components/board/BoardListLink";
import PaginationLink from "@/components/board/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

const {filterConfig} = boardFilterUtil;

export default {
  name: "BoardListComponent",
  mixins: [alertMixins, filterMixins, listMixins, boardFilterUtil, boardTemplateUtil],
  components: {BoardFilterLink, BoardListLink, PaginationLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      boardListSetData: this.setData,
      changeSeqData: this.changeSeqData,
    }
  },

  props: {
    boardType: '',
    memberKey:{default:0}
  },
  data() {
    return {
      listLayout: '',
      listApiParamSet: {},
      filterLayout: '',
      paginationLayout: '',
      paginationType: '',
      getFunc: '',

      writeFunc: '',
      writeApiParamSet: '',
      seqName: '',
      keyName: '',

      filterDate: '',
      filterSort: false,
    }
  },
  created() {
    this.setFilterConfig(filterConfig)
    this.setParserType('url', this.$route.fullPath);
    this.initConfig()
  },
  mounted() {
    this.getList(true)
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.filterLayout = boardTemplateConfig.filterLayout;
      this.paginationLayout = boardTemplateConfig.paginationLayout;

      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.paginationType = boardFilterConfig.paginationType;
      this.getFunc = boardFilterConfig.getFunc;
      this.writeFunc = boardFilterConfig.writeFunc;
      this.writeApiParamSet = boardFilterConfig.writeApiParamSet;
      this.seqName = boardFilterConfig.seqName;
      this.keyName = boardFilterConfig.keyName;

      boardFilterConfig.pageRow && boardFilterConfig.pageRow != 10 ? this.filterSet.page.size = boardFilterConfig.pageRow : '';
      if(this.memberKey !== 0){
        this.listApiParamSet.no = this.memberKey
      }


      let listOptions = {
        url: this.$api.$board[this.getFunc],
        defaultParams: this.listApiParamSet,
      }
      this.initList('api', listOptions)
    },

    setData(key, value) {
      this[key] = value;
    },
    changeSeqData(row) {
      let params = {};
      if(!util.isEmpty(this.writeApiParamSet)) {
        params = JSON.parse(JSON.stringify(this.writeApiParamSet));
      }
      params[this.keyName] = row[this.keyName];
      params[this.seqName] = row[this.seqName];

      try {
        this.$api.$board[this.writeFunc](params).then(res => res.Data.Result).then(res => {
          if(res.Info.type === 1) {
            this.getList();
            this.errorAlert('저장되었습니다.')
          }else{
            this.errorAlert('저장에 실패하였습니다.')
          }
        })
      }catch (e) {
        console.log(e);
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
